import React, { type ReactNode } from 'react';
import {
  Image,
  View,
  type DimensionValue,
  type ImageSourcePropType,
} from 'react-native';

type Props = {
  icon: ImageSourcePropType;
  center?: boolean;
  children: ReactNode;
  iconW?: DimensionValue;
  iconH?: DimensionValue;
};

export const ContactCard = ({
  icon,
  center,
  children,
  iconW = 24,
  iconH = 24,
}: Props) => {
  return (
    <View className="py-4 px-6 p flex-row bg-secondary-200 rounded-lg mt-4">
      <View
        className={`${center ? 'justify-center' : 'justify-start'}`}
        style={{
          justifyContent: center ? 'center' : 'flex-start',
        }}
      >
        <Image
          source={icon}
          style={{ resizeMode: 'contain', width: iconW, height: iconH }}
        />
      </View>
      <View className="ml-6">{children}</View>
    </View>
  );
};
